import React, {Component} from 'react';
import MCIcon from "../../icon/MCIcon";
import {shuffle} from "lodash";
require("./Pexeso.scss");

const icons = ['aa', 'autoprovoz', 'cgc', 'cnr', 'cpl', 'dms', 'doc', 'dpl', 'dpv', 'elg', 'eno', 'eos', 'esp', 'ezam', 'helpdesk', 'kevis', 'mapio', 'mcadmin', 'mis', 'os', 'pes', 'pp', 'rb', 'ren', 'rob', 'rzp', 'spub', 'tech', 'usn', 'vlb', 'xbanka', 'xrn', 'xspis', 'xzr'];

class Pexeso extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fields: null,
            flipped: 0,
            previous: null,
            lock: false
        }
    }

    componentDidMount() {
        this.newGame();
    }

    newGame = () => {

        let x = 5;
        let y = 6;

        let iconsRandom = shuffle(icons);
        const cards = x * y;
        let cardsArray = [];
        for(let i = 0; i < cards / 2; i++) {
            cardsArray.push(iconsRandom[i]);
            cardsArray.push(iconsRandom[i]);
        }

        cardsArray = shuffle(cardsArray);

        let fields = new Array(x);

        for (let i = 0; i < x; i++) {
            fields[i] = new Array(y);
            for (let j = 0; j < y; j++) {
                fields[i][j] = {visible: false, check: false, icon: cardsArray[(i * y) + j], i, j};
            }
        }

        this.setState({
            fields: fields,
            flipped: 0,
            previous: null,
            lock: false
        })
    };

    flip = (i, j) => {
        const {fields, previous, lock} = this.state;

        if (lock || (previous && previous.i === i && previous.j === j)) {
            return;
        }

        fields[i][j].visible = true;
        let previousNew;
        let lockNew = false;
        if (previous) {

            lockNew = true;
            const c1 = fields[i][j];
            const c2 = fields[previous.i][previous.j];

            if (c1.icon !== c2.icon) {
                setTimeout(() => {
                    c1.visible = false;
                    c2.visible = false;
                    this.setState({
                        fields,
                        lock: false
                    });
                }, 1500);
            } else {
                setTimeout(() => {
                    c1.check = true;
                    c2.check = true;
                    this.setState({
                        fields
                    });
                }, 600);
                lockNew = false;
            }

            previousNew = null;
        } else {
            previousNew = {i,j};
        }

        this.setState({
            fields,
            previous: previousNew,
            lock: lockNew
        });
    };

    renderMcIcon = () => {
        return <svg className="frontIcon" version="1.0" xmlns="http://www.w3.org/2000/svg" width="80px" height="60px" viewBox="0 0 2900 2180" preserveAspectRatio="xMidYMid meet">
            <g id="layer101" fill="#8a95c5" stroke="none">
                <path d="M2107 2004 c-4 -4 -7 -190 -7 -413 l0 -406 303 -303 c167 -167 306 -300 310 -296 4 4 7 190 7 413 l0 406 -303 303 c-167 167 -306 300 -310 296z"/>
            </g>
            <g id="layer102" fill="#2295a7" stroke="none">
                <path d="M147 1993 c-4 -3 -7 -187 -7 -407 l0 -401 503 -502 c516 -515 525 -523 597 -523 63 0 97 24 258 183 l163 161 -748 748 c-411 411 -751 748 -754 748 -3 0 -9 -3 -12 -7z"/>
                <path d="M1132 1988 c-9 -9 -12 -109 -12 -408 l0 -395 503 -502 c451 -451 506 -503 546 -513 51 -13 103 -6 146 20 17 11 96 86 177 167 l148 148 -748 748 c-589 589 -750 745 -760 735z"/>
            </g>
        </svg>
    };

    render() {
        const {fields} = this.state;

        return (
            <div className="pexeso">
                <div className="actions">
                    <button onClick={this.newGame}>Nová hra</button>
                </div>
                <table>
                {fields && fields.map(((arr, xIndex) => {
                    return <tr key={xIndex}>
                        {arr.map((item, yIndex) => {
                            const cn = "flip-container" + (item.visible ? " flip" : "");
                            const cnCheck = "back" + (item.check ? " check" : "");
                            return <td className={cn} key={xIndex + ',' + yIndex}>
                                <div className="flipper">
                                    <div className="front" onClick={() => this.flip(xIndex, yIndex)}>
                                        {this.renderMcIcon()}
                                    </div>
                                    <div className={cnCheck}>
                                        <MCIcon icon={item.icon} size="4x" />
                                    </div>
                                </div>
                            </td>
                        })}
                    </tr>
                }))}
                </table>
            </div>
        )
    }
}

export default Pexeso;
